import { useEffect, useRef } from "react";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default function GoogleLogin({authCallback}) {
  const divRef = useRef(null);

  console.log("GOOGLE_CLIENT_ID", GOOGLE_CLIENT_ID);

  useEffect(() => {
    if (!window.google) return;

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
    });

    window.google.accounts.id.renderButton(divRef.current, {
      theme: "outline",
      size: "large",
    });

    // Optional: auto prompt
    // window.google.accounts.id.prompt();
  }, []);

  function handleCredentialResponse(response) {
    const token = response.credential;

    authCallback({
      token: token,
      email: JSON.parse(atob(token.split('.')[1])).email,
    });
  }

  return <div ref={divRef} />;
}